import { ReactNode } from 'react';

import { cn } from '@/utils/tailwind';

import {
  CELL_PADDING,
  MAX_CELL_HEIGHT,
} from '../../DatasetSessionCompare.utils';
import { DEFAULT_COLUMN_WIDTHS } from '../../constants';
import { isInPlayground } from '../../utils/isInPlayground';

interface MetadataCellProps {
  isTextTruncated: boolean;
  backgroundStyles: string;
  columnWidthStorage: number[];
  columnIndex: number;
  metadataContent: ReactNode;
}

export function MetadataCell({
  isTextTruncated,
  backgroundStyles,
  columnWidthStorage,
  columnIndex,
  metadataContent,
}: MetadataCellProps) {
  const inPlayground = isInPlayground();
  const width = columnWidthStorage[columnIndex] ?? DEFAULT_COLUMN_WIDTHS;

  return (
    <td
      className={cn(
        'group relative border-b border-r border-secondary bg-background transition-colors',
        !isTextTruncated && 'align-top',
        backgroundStyles
      )}
      data-column={columnIndex}
      style={{
        ...CELL_PADDING(inPlayground ? 'lg' : 'sm'),
        width,
        maxWidth: width,
        minWidth: width,
      }}
    >
      <div
        className={cn(
          'flex h-full max-w-full items-center justify-between',
          !isTextTruncated ? 'flex-col items-start gap-2' : 'gap-2'
        )}
      >
        <div
          className={cn(
            'flex w-full overflow-hidden',
            !isTextTruncated && inPlayground && `overflow-y-auto`
          )}
          data-testid="dataset-session-compare-metadata"
          style={{
            maxHeight: !isTextTruncated ? MAX_CELL_HEIGHT : undefined,
          }}
        >
          {metadataContent}
        </div>
      </div>
    </td>
  );
}
